<!DOCTYPE HTML>
<template>
<div class="available-projects">
  <b-table :items="projects"
           :fields="fields"
           class="availableProjects"
           show-empty
           selectable
           hover
           @row-clicked="rowClicked" />
</div>
</template>

<script>
// Firebase
const firebase = require( '@/firebaseConfig.js' )
// Mixins
import { Formatter, Skills, Status } from '@/mixins/Mixins.js'
export default {
  name: 'ProjectsTable',
  components: {},
  props: {
    userData: Object,
  },
  mixins: [ Formatter, Skills, Status ],
  data() {
    return {
      projects: [],
    }
  },
  firestore: {
    projects: firebase.db.collection( 'projects' ),
  },
  computed: {
    fields() {
      return [ {
          key: 'name',
          label: 'Project',
          sortable: true
        },
        {
          key: 'budget',
          label: 'Budget',
          sortable: true,
          sortByFormatted: true,
          formatter: ( value, key, item ) => {
            return this.asCurrency( item.budget )
          }
        },
        {
          key: 'skills',
          label: 'Relevant skills',
          sortable: true,
          sortByFormatted: true,
          formatter: ( value, key, item ) => {
            let n = this.relevantSkills( item, this.userData ).length
            return n ? n : null
          }
        },
        {
          key: 'timeline',
          label: 'Timeline',
          sortable: true,
        },
        {
          key: 'status',
          label: 'Status',
          sortable: true,
          sortByFormatted: true,
          formatter: ( value, key, item ) => {
            return this.shortStatus( item, this.userData )
          }
        },
      ]
    },
  },
  methods: {
    rowClicked( record ) {
      this.$emit( 'open-project', record )
    }
  }
}
</script>

<style lang="scss">
@import "@/styles/global.scss";
.available-projects {}
</style>
